module.exports = __webpack_public_path__ + "img/Banner-courier-covid-19.61c8d36a.png";